import React from 'react';
import { BRAND } from '../../data/mock';
import { Button } from '../ui/button';
import { ArrowRight, CheckCircle, Heart } from 'lucide-react';

export const CaseStudySection = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* French Bulldog Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_petcover-broker/artifacts/0haf4wq1_IMG_2901.jpeg"
                alt="Adorable French Bulldog - Protected by Pet Insurance"
                className="w-full h-auto object-cover"
              />
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 bg-gradient-to-br from-teal-500 to-cyan-600 text-white rounded-2xl p-4 shadow-xl hidden md:block">
              <div className="flex items-center gap-2">
                <Heart className="w-8 h-8 fill-white" />
                <div>
                  <p className="text-lg font-bold">Protected</p>
                  <p className="text-sm text-white/80">& Loved</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Peace of Mind
            </span>
            
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Your Best Friend Deserves the Best Protection
            </h2>
            
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              Every pet parent knows that feeling — the worry when your furry friend isn't feeling well. 
              With the right pet insurance, you can focus on what matters most: getting them the care they need, 
              not the cost.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-emerald-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-slate-800">Up to 90% Reimbursement</p>
                  <p className="text-slate-600 text-sm">Get most of your vet bills covered</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-emerald-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-slate-800">24/7 Vet Chat Included</p>
                  <p className="text-slate-600 text-sm">Get answers anytime, day or night</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-emerald-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-slate-800">No Breed Restrictions</p>
                  <p className="text-slate-600 text-sm">Every pet is welcome, including Frenchies!</p>
                </div>
              </div>
            </div>
            
            <Button
              asChild
              size="lg"
              className="text-white font-bold shadow-lg shadow-orange-500/25"
              style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
            >
              <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
                Get Your Free Quote
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
